import '../sass/text-and-image-tabs.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const detailsScript = document.querySelector('#ofg-education-details-js');
    const $blocks = document.querySelectorAll('.block.text-and-image-tabs');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $accordions = $block.querySelectorAll('.text-and-image-tabs__accordion');
        const $carousel = $block.querySelector('.text-and-image-tabs__carousel');
        const $carouselBtns = $block.querySelectorAll('.text-and-image-tabs__carousel-btn');

        let accordions = [];

        const initDetails = () => {
            if ($accordions) {
                $accordions.forEach(($accordion, index) => {
                    const accordion = new Details($accordion, {
                        allowClose: false
                    });

                    accordions.push(accordion);

                    $accordion.addEventListener('detailsopen', () => {
                        const closedAccordions = accordions.filter((accordion, closeAccordionIndex) => closeAccordionIndex !== index);

                        closedAccordions.forEach(accordion => {
                            accordion.close();
                        });
                    });
                });
            }
        };

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                autoHeight: true,
            });

            carousel.on('slideChange', () => {
                if (!$carouselBtns) return;

                $carouselBtns.forEach($carouselBtn => {
                    const { index } = $carouselBtn.dataset;

                    if (index == carousel.realIndex) {
                        $carouselBtn.classList.add('text-and-image-tabs__carousel-btn--active');
                        $carouselBtn.setAttribute('aria-expanded', 'true');
                    } else {
                        $carouselBtn.classList.remove('text-and-image-tabs__carousel-btn--active');
                        $carouselBtn.setAttribute('aria-expanded', 'false');
                    }
                });
            });

            if ($carouselBtns) {
                $carouselBtns.forEach($carouselBtn => {
                    $carouselBtn.addEventListener('click', () => {
                        const { index } = $carouselBtn.dataset;

                        carousel.slideTo(index);
                    });
                });
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }

        if (typeof Details !== 'undefined') {
            initDetails();
        } else if (detailsScript) {
            detailsScript.addEventListener('load', () => {
                initDetails();
            });
        } else {
            window.addEventListener('load', () => {
                const detailsScript = document.querySelector('#ofg-education-swiper-js');

                if (!detailsScript) return;

                initDetails();
            });
        }
    });
})();
